// react components
import React from 'react'

// props
type FormSeparator825Props = {
    text: string
}

// main
export const FormSeparator825: React.FC<FormSeparator825Props> = React.memo(({
    text,
}) => {
    return (
        <div className='form-separator-825'>
            <p>{text}</p>
        </div>
    )
})
